import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./AddedToWatchlistAlert.css";

export default function AddedToWatchlistAlert({
  open,
  onClose,
  vehicleName,
}) {
  useEffect(() => {
    if (!open) return;
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  const content = (
    <div
      className="watchlist-alert-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="watchlist-alert-title"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="watchlist-alert">
        <button
          type="button"
          className="watchlist-alert-close"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseOutlined />
        </button>

        <div className="watchlist-alert-header">
          <div className="watchlist-alert-icon-wrap">
            <CheckOutlined className="watchlist-alert-icon" />
          </div>
          <div className="watchlist-alert-titles">
            <h2 id="watchlist-alert-title" className="watchlist-alert-title">
              Added to Watchlist
            </h2>
            {vehicleName && (
              <p className="watchlist-alert-subtitle">{vehicleName}</p>
            )}
          </div>
        </div>

        {vehicleName && (
          <p className="watchlist-alert-message">
            {vehicleName} is now being tracked.
          </p>
        )}
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
